import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";

const CandidateMaxUpdateDateModal = (props) => {
    const [content, setContent] = useState({
        candidate_id: '',
        max_cv_update_year: '',
        max_career_update_year: '',
    });

    const {candidateId, isShow, onClose} = props

    const fetchMaxUpdateYear = (canId) => {
        if (!canId) {
            return;
        }
        CandidateService.getMaxUpdateYear(canId).then((res) => {
            setContent(res.content)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        })
    };

    useEffect(() => {
        if (isShow) {
            fetchMaxUpdateYear(candidateId)
        }
    }, [isShow]);

    const onCloseModal = () => {
        onClose()
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={() => onCloseModal()}
                   animation={false} style={{zIndex: 3001}}>
                <Modal.Header>
                    <Modal.Title>Thông tin Update đến</Modal.Title>
                    <Button variant='secondary' onClick={() => onCloseModal()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className={'row'}>
                        <div className={'col-sm-12'}>Update đến: {content.max_cv_update_year > content.max_career_update_year ?  content.max_cv_update_year : content.max_career_update_year}</div>
                        <div className={'col-sm-6'}>Year extract from all CVs: {content.max_cv_update_year}</div>
                        <div className={'col-sm-6'}>Max year tại career summary: {content.max_career_update_year}</div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CandidateMaxUpdateDateModal;
